import { makeStyles, theme } from "cdh-data-portal-theme"
import { SIDEBAR_WIDTH } from "../../molecules/Sidebar/Sidebar.static"

export const useStyles = makeStyles()(() => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.colors.globalBackgroundLight,
    paddingBottom: 42,
    paddingLeft: 42,
    paddingRight: 42,
    paddingTop: 89,
    marginLeft: SIDEBAR_WIDTH,
  },
  title: {
    "&&": {
      fontSize: 42,
      fontWeight: 450,
      lineHeight: "68px",
      margin: 0,
    },
  },
  subtitle: {
    "&&": {
      fontSize: 26,
      fontWeight: 400,
      lineHeight: "42px",
      margin: "4px 0 0 0",
    },
  },
  tabs: {
    marginTop: 24,
  },
  tabContent: {
    marginTop: 24,
  },
}))
